module.exports = __webpack_public_path__ + "static/media/onlyfans.a55e0d5b.png";